module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_maedori_03@3x-3df6f908766650822a07f759b3b9058e.webp";